import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Switch,
  Tooltip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  TablePagination,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Close from "@mui/icons-material/Close";
// import { Add, Edit, Delete, Link, Close } from "@mui/icons-material";

import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch, useDelete, useUpdate } from "../../hooks";

import SnackbarComponent from "../../components/SnackBar/snackBar";

const triggerTypes = ["Automatic", "Manual"];
const approvalOptions = ["Not allowed", "Required", "Not Required (Open)"];

const AdminBadge = () => {
  // const [badges, setbadges] = useState();
  const [rows, setRows] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    severity: "success", // Default severity
    message: "",
    position: { vertical: "top", horizontal: "center" },
  });
  const loginToken = useSelector((state) => state.user.logintoken);

  const {
    data: ribbonData,
    isLoading: isBadgeLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllRibbons"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: createBadgesData,
    error: createBadgesError,
    fetchData: fetchCreateData,
  } = useFetch(BASE_URL_TEST + urls("createRibbons"), {
    method: "POST",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  console.log("rowpage", rowsPerPage, page);
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (createBadgesError) {
    } else if (createBadgesData && createBadgesData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        open: true,
        message: createBadgesData["message"],
        position: { vertical: "top", horizontal: "center" },
        severity: "success",
      });
      setModalOpen(false);
      fetchData();
    }
  }, [createBadgesData, createBadgesError]);

  useEffect(() => {
    if (error) {
    } else if (ribbonData && ribbonData["status"] === true) {
      // console.log("ribbonDataBadge",ribbonData['data'])
      // setRows(ribbonData['data'])
      const ribbonOnly = ribbonData["data"].filter(
        (item) => item.type === "badge"
      );
      setRows(ribbonOnly);
    }
  }, [ribbonData, error]);

  const {
    data: updatedRibbonsData,
    isLoading: updatedRibbonsLoading,
    error: updatedRibbonsError,
    updateData: fetchUpdateData,
  } = useUpdate(BASE_URL_TEST, {
    method: "PUT",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: deletedRibbonsData,
    isLoading: deletedRibbonsLoading,
    error: deletedRibbonsError,
    deleteData: fetchDeleteData,
  } = useDelete(BASE_URL_TEST, {
    method: "DELETE",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  useEffect(() => {
    if (deletedRibbonsError) {
    } else if (deletedRibbonsData && deletedRibbonsData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        open: true,
        message: deletedRibbonsData["message"],
        position: { vertical: "top", horizontal: "center" },
        severity: "success",
      });
      setModalOpen(false);
      setSelectedRows([]);
      fetchData();
    }
  }, [deletedRibbonsData, deletedRibbonsError]);

  useEffect(() => {
    if (updatedRibbonsError) {
    } else if (updatedRibbonsData && updatedRibbonsData["status"] === true) {
      console.log("updatedRibbonsData", updatedRibbonsData["data"]);

      setSnackbarState({
        ...snackbarState,
        open: true,
        message: updatedRibbonsData["message"],
        position: { vertical: "top", horizontal: "center" },
        severity: "success",
      });
      setModalOpen(false);
      fetchData();
    }
  }, [updatedRibbonsData, updatedRibbonsError]);

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogData, setDialogData] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [badgeNameError, setBadgeNameError] = useState("");
  const [newBadge, setNewBadge] = useState({
    id: "",
    image: "",
    name: "",
    triggerType: "",
    approval: "",
    addedOn: "",
    status: true,
    imageFile: null, // Store the uploaded image file
  });

  // Handle Search
  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  // const filteredBadges = rows.filter((row) =>
  //   row.name.toLowerCase().includes(searchTerm.toLowerCase())
  // );

  const filteredBadges = searchTerm
    ? rows.filter(
        (item) =>
          item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.description.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : rows;

  // Handle Checkbox Selection
  // const handleSelectRow = (id) => {
  //   setSelectedRows((prev) =>
  //     prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
  //   );
  // };

  const handleSelectRow = (row) => {
    console.log("rowdsles", row);
    setSelectedRows((prevSelected) => {
      const isSelected = prevSelected.some(
        (selectedRow) => selectedRow.badge_id === row.badge_id
      );

      if (isSelected) {
        return prevSelected.filter(
          (selectedRow) => selectedRow.badge_id !== row.badge_id
        );
      } else {
        return [...prevSelected, row];
      }
    });
  };

  // Activate Rows
  const handleActivate = () => {
    console.log("selectedrows Badge", selectedRows);
    selectedRows.forEach(async (item) => {
      console.log("Active item Badge:", item);

      const formdata = new FormData();
      formdata.append("name", item["name"]);
      formdata.append("type", "badge");
      formdata.append("description", "testing");
      formdata.append("badgeImage", item["image_url"]);
      formdata.append("triggerType", "null");
      formdata.append("apporval", "null");
      formdata.append("status", 1);

      const updateUrl = urls("updateRibbons", item["badge_id"]);

      try {
        const response = await fetchUpdateData(updateUrl, formdata);
        console.log(`Badge ${item.badge_id} updated successfully`, response);
      } catch (error) {
        console.error(`Error updating badge ${item.badge_id}`, error);
      }
    });
    setSelectedRows([]);
  };

  // Deactivate Rows
  const handleDeactivate = () => {
    console.log("selectedrows Badge", selectedRows);
    selectedRows.forEach(async (item) => {
      console.log("Active item deac Badge:", item);

      const formdata = new FormData();
      formdata.append("name", item["name"]);
      formdata.append("type", "badge");
      formdata.append("description", "testing");
      formdata.append("badgeImage", item["image_url"]);
      formdata.append("triggerType", "null");
      formdata.append("apporval", "null");
      formdata.append("status", 0);

      const updateUrl = urls("updateRibbons", item["badge_id"]);

      try {
        const response = await fetchUpdateData(updateUrl, formdata);
        console.log(`Badge ${item.badge_id} updated successfully`, response);
      } catch (error) {
        console.error(`Error updating badge ${item.badge_id}`, error);
      }
    });
    setSelectedRows([]);
  };

  // Delete Rows
  const handleDelete = (id) => {
    const deleteUrl = urls("deleteRibbons", id);

    fetchDeleteData(deleteUrl);
  };
  const handleMultiDelete = (selectedData) => {
    console.log("selectedData", selectedData);
    if (selectedData && selectedData.length > 0) {
      for (const badge of selectedData) {
        const deleteUrl = urls("deleteRibbons", badge.badge_id);
        fetchDeleteData(deleteUrl);
      }
    }
    //  const deleteUrl = urls('deleteRibbons', id);

    //        fetchDeleteData(deleteUrl)
  };

  // Handle Switch Toggle
  const handleToggleStatus = (id) => {
    setRows((prev) =>
      prev.map((row) => (row.id === id ? { ...row, status: !row.status } : row))
    );
  };

  // Handle Dialog Open/Close
  const handleDialogOpen = (data, isEdit = false) => {
    console.log("dataedit", data);
    setIsEditMode(isEdit);
    if (isEdit) {
      setNewBadge(data);
    } else {
      setNewBadge({
        id: "",
        image: "",
        name: "",
        triggerType: "",
        approval: "",
        addedOn: "",
        status: true,
        imageFile: null,
      });
    }
    setDialogData(data);
    setModalOpen(true);
  };

  const handleDialogClose = () => {
    setModalOpen(false);
    setDialogData(null);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setNewBadge((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setNewBadge((prev) => ({
        ...prev,
        imageFile: file,
        image: URL.createObjectURL(file), // Preview the image
      }));
    }
  };

  const handleSave = () => {
    if (isEditMode) {
      console.log("currenBadge", newBadge);

      const formdata = new FormData();
      formdata.append("name", newBadge["name"]);
      formdata.append("type", "badge");
      formdata.append("description", "testing");
      formdata.append("badgeImage", newBadge["imageFile"]);
      formdata.append("triggerType", newBadge["triggerType"]);
      formdata.append("apporval", newBadge["approval"]);
      formdata.append("status", newBadge["status"]);

      const updateUrl = urls("updateRibbons", newBadge["badge_id"]);
      fetchUpdateData(updateUrl, formdata);
    } else {
      if (!newBadge["name"].trim()) {
        setBadgeNameError("Badge name is required");
        return;
      } else {
        const formdata = new FormData();
        formdata.append("name", newBadge["name"]);

        formdata.append("type", "badge");
        formdata.append("description", "testing");
        formdata.append("badgeImage", newBadge["imageFile"]);
        formdata.append("triggerType", "null");
        formdata.append("apporval", "null");

        fetchCreateData(formdata);
      }
    }
    setModalOpen(false);
    setNewBadge({
      id: "",
      image: "",
      name: "",
      triggerType: "",
      approval: "",
      addedOn: "",
      status: true,
      imageFile: null,
    });
  };

  const handleSnackbarClose = () => {
    setSnackbarState((prev) => ({ ...prev, open: false }));
  };
  return (
    <Box sx={{ padding: 3, backgroundColor: "#F9FAFC" }}>
      {/* Header */}

      <SnackbarComponent
        open={snackbarState.open}
        onClose={handleSnackbarClose}
        severity={snackbarState.severity}
        message={snackbarState.message}
        position={snackbarState.position}
      />
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom={2}
      >
        <Typography variant="h6">Badges</Typography>
        <Button
          variant="contained"
          startIcon={<AddCircleOutlineIcon />}
          color="primary"
          onClick={() => handleDialogOpen(null, false)}
        >
          New Badge
        </Button>
      </Box>

      {/* Search and Actions */}
      <Box display="flex" gap={2} marginBottom={2}>
        <TextField
          variant="outlined"
          placeholder="Search by badge name"
          size="small"
          value={searchTerm}
          onChange={handleSearch}
          fullWidth
        />
        <Button variant="contained" color="primary">
          Search
        </Button>
        <Button variant="outlined" onClick={handleActivate}>
          Activate
        </Button>
        <Button variant="outlined" onClick={handleDeactivate}>
          Deactivate
        </Button>
        <Button
          variant="outlined"
          color="error"
          sx={{display:'none'}}
          onClick={() => handleMultiDelete(selectedRows)}
        >
          Delete
        </Button>
      </Box>

      <Box>
        {isBadgeLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <CircularProgress />
          </Box>
        ) : null}
      </Box>

      {/* Table */}
      <TableContainer
        component={Paper}
        sx={{ borderRadius: "20px", borderRadius: 2, boxShadow: 2 }}
      >
        <Table>
          <TableHead sx={{ backgroundColor: "#F5F5F5" }}>
            <TableRow>
              <TableCell padding="checkbox">
                <Checkbox
                  indeterminate={
                    selectedRows.length > 0 && selectedRows.length < rows.length
                  }
                  checked={selectedRows.length === rows.length}
                  onChange={() =>
                    setSelectedRows(
                      selectedRows.length === rows.length
                        ? []
                        : rows.map((row) => row.id)
                    )
                  }
                />
              </TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Image</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
              <TableCell sx={{ fontWeight: "bold", display: "none" }}>
                Trigger Type
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", display: "none" }}>
                Approval
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", display: "none" }}>
                Added On
              </TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredBadges.length > 0 ? (
              filteredBadges
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map(
                  (row) =>
                    row.type === "badge" && (
                      <TableRow key={row.badge_id}>
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={selectedRows.some(
                              (item) => item.badge_id === row.badge_id
                            )}
                            onChange={() => handleSelectRow(row)}
                          />
                        </TableCell>
                        <TableCell>
                          {row.image_url ? (
                            <img
                              src={row.image_url}
                              alt="Badge"
                              style={{
                                width: 50,
                                height: 50,
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            <Typography>{row.image_url}</Typography>
                          )}
                        </TableCell>
                        <TableCell>{row.name}</TableCell>
                        <TableCell sx={{ display: "none" }}>
                          {row.triggerType}
                        </TableCell>
                        <TableCell sx={{ display: "none" }}>
                          {row.apporval}
                        </TableCell>
                        <TableCell sx={{ display: "none" }}>
                          {row.addedOn}
                        </TableCell>
                        <TableCell>
                          <Typography
                            color={row.status === 1 ? "green" : "gray"}
                            fontWeight={"bold"}
                          >
                            {row.status === 1 ? "Active" : "InActive"}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Tooltip title="Edit">
                            <IconButton
                              color="primary"
                              onClick={() => handleDialogOpen(row, true)}
                            >
                              <EditIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete" sx={{display:'none'}}>
                            <IconButton
                              color="error"
                              onClick={() => handleDelete(row.badge_id)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    )
                )
            ) : (
              <TableRow>
                <TableCell colSpan={4} style={{ textAlign: "center" }}>
                  No data found for the searched product.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50, 100]}
        component="div"
        count={rows && rows.length ? rows.length : 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      {/* Dialog */}
      <Dialog open={isModalOpen} onClose={handleDialogClose} fullWidth>
        <DialogTitle>
          {isEditMode ? "Edit Badge" : "New Badge"}
          {/* Close Icon in the Top-Right Corner */}
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleDialogClose}
            sx={{ position: "absolute", right: 20, top: 8 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <TextField
            label="Name"
            name="name"
            value={newBadge.name}
            onChange={handleChange}
            fullWidth
            margin="normal"
            error={!!badgeNameError}
            helperText={
              badgeNameError && (
                <Typography
                  sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                >
                  {badgeNameError}
                </Typography>
              )
            }
          />

          {isEditMode ? (
            <FormControl fullWidth sx={{ mb: 5 }}>
              <InputLabel>Status</InputLabel>
              <Select
                value={newBadge.status || 0} // Default to 0 (Deactive) if status is not set
                onChange={(e) =>
                  setNewBadge((prev) => ({ ...prev, status: e.target.value }))
                }
                label="Status"
              >
                <MenuItem value={1}>Active</MenuItem>
                <MenuItem value={0}>Deactive</MenuItem>
              </Select>
            </FormControl>
          ) : null}

          {newBadge.image && (
            <Box
              sx={{
                maxWidth: 100,
                maxHeight: 100,
                overflow: "hidden",
                marginBottom: 2,
              }}
            >
              <img
                src={newBadge.image}
                alt="Uploaded preview"
                style={{ width: "100%", height: "auto" }}
              />
            </Box>
          )}

          {/* Trigger Type Dropdown */}
          <FormControl fullWidth margin="normal" sx={{ display: "none" }}>
            <InputLabel>Trigger Type</InputLabel>
            <Select
              name="triggerType"
              value={newBadge.triggerType}
              onChange={handleChange}
              sx={{ mb: 2, top: 8 }}
            >
              {triggerTypes.map((type) => (
                <MenuItem key={type} value={type}>
                  {type}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Approval Dropdown */}
          <FormControl fullWidth margin="normal" sx={{ display: "none" }}>
            <InputLabel>Approval</InputLabel>
            <Select
              name="approval"
              value={newBadge.apporval}
              onChange={handleChange}
              sx={{ mb: 2, top: 8 }}
            >
              {approvalOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Image Upload */}
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            style={{ marginBottom: "16px" }}
          />
          {newBadge.image_url && (
            <Box
              sx={{
                maxWidth: 100,
                maxHeight: 100,
                overflow: "hidden",
                marginBottom: 2,
              }}
            >
              <img
                src={newBadge.image_url}
                alt="Uploaded preview"
                style={{ width: "100%", height: "auto" }}
              />
            </Box>
          )}
        </DialogContent>

        <DialogActions>
          <Button variant="contained" onClick={handleDialogClose} color="error">
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={handleSave}>
            {isEditMode ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AdminBadge;
